import { AsyncSelect, watermelon } from '@waylay/react-components'
import clientContainer from '~/lib/client'

export const findTemplates = async (filter: string) => {
  const templates = await clientContainer.client.templates.list(filter)

  return ((templates as any[]) || []).map(template => ({
    ...template,
    label: template.name,
    value: template.name,
  }))
}

interface ITemplateSelect {
  name?: string
  template?: string
  onChange: Function
  isMulti?: boolean
  placeholder?: string
  isError?: boolean
}

const noOptionsMessage = ({ inputValue }) =>
  inputValue.length
    ? `No templates found containing '${inputValue}'`
    : 'Start typing…'

const TemplateSelect = (props: ITemplateSelect) => {
  const { template, onChange, ...rest } = props

  const loadOptions = async filter => await findTemplates(filter)

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      styles={{
        control: baseStyles => ({
          ...baseStyles,
          borderColor: props.isError ? watermelon : '#e6e6e6',
          '&:hover': {
            borderColor: props.isError ? watermelon : '#b3b3b3',
          },
        }),
      }}
      aria-label="template-select"
      isClearable
      key={`template-select-${template}`}
      value={template ? { label: template, value: template } : undefined}
      noOptionsMessage={noOptionsMessage}
      loadOptions={loadOptions}
      onChange={v => onChange(v || {})}
      {...rest}
    />
  )
}

export default TemplateSelect
